
import { CostCentreEntityDecorator } from './cost-centre.decorator';
import { CostCentre } from './cost-centre.model';
import { CrudTypeInfo } from '@scisys-uim/uim-common';


export abstract class CostCentreTypeInfoBase implements CrudTypeInfo<CostCentre, string> {
  name = 'Cost Centre';
  entityDecorator = new CostCentreEntityDecorator();
  
  createAuthorities = ['WRITE_COST_CENTRE'];
  editAuthorities = ['WRITE_COST_CENTRE'];
  deleteAuthorities = ['WRITE_COST_CENTRE'];
  viewAuthorities = ['READ_COST_CENTRE'];
  
  searchRouteBase = ['/costcentre/search'];
  createRouteBase = ['/costcentre/create'];
  editRouteBase = ['/costcentre/edit'];
  viewRouteBase = ['/costcentre/view'];
  
  description(item: CostCentre): string {
    return '' +  item.ccId +  ' - ' +  item.name;
  }
}



